/* ------------------------------------*\
    VARIABLE DECLARATION
\*------------------------------------*/
$(window).on('load', () => {
    /*------------------------------------*\
        CALL TO FUNCTIONS
    \*------------------------------------*/


    if (isSingleProduct()) {
        // console.log(
        //     '<!-- ----------------------------------------------------- -->\n' +
        // '<!-- Product -->\n' +
        // '<!-- ----------------------------------------------------- -->');
        setupSingleProduct();

    }

});

/*------------------------------------*\
Single Product
\*------------------------------------*/
function setupSingleProduct() {
    //specific for mobile
    if(deviceDetector.device == 'desktop'){
        // You're on a desktop.
        // console.log('desktop');
    }else{
        if(deviceDetector.device == 'tablet'){
            // You're on a tablet.
            // console.log('tablet');
        }else{
            // console.log('phone');
        }
        // You're on a phone.
    }
    setupShippingPopup();
    //check if is simple
    if($('.p-product').data('product-type')==="simple"){
        // console.log('Simple Product');
        setupSimpleProductSelect2();
    }else if($('.p-product').data('product-type')==="variable-subscription"){
        // console.log('Variable Subscription');
        setupVariableSubscription();
        // setup6BottleCheckbox();
    }else if($('.p-product').data('product-type')==="variable"){
        // console.log('Variable product');
        setupVariableProduct();

    }

}

/*------------------------------------*\
Common Product methods
\*------------------------------------*/

function setupShippingPopup(){
    var $shipping_toggle = $('#p-product-top-right-shipping-toggle-span, .shipping-popup-close');
    var $shipping_popup = $('.p-product-top-right-shipping-popup');
    $shipping_toggle.on('click',function(){
        $shipping_popup.toggleClass('active');
    });
}

/*------------------------------------*\
Simple Product methods
\*------------------------------------*/

function setupSimpleProductSelect2(){

    const $select2_object = $('.p-product-top-right-qtty-select');
    if(!$select2_object.hasClass('.select2-hidden-accessible')){
        $select2_object.select2({
            placeholder:'QTY.',
            debug: true,
            minimumResultsForSearch: -1, //remove search

        });
        $select2_object.on("select2:select", function (e) {
            // console.log(e.params.data.id);
        });
    }
}
